import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NameAvatarCell } from './NameAvatarCell';
import { OptionsCell } from './OptionsCell';

function RowLoading({ forwardedRef }) {
  return (
    <TableRow
      ref={forwardedRef}
      sx={{
        '& .MuiTableCell-root': {
          px: 1.5,
          py: 0.6,
        },
      }}
    >
      <TableCell>
        <Stack direction="row" gap={1}>
          <Skeleton variant="circular" width="40px" height="40px" />
          <Skeleton variant="text" sx={{ flexGrow: 1 }} />
        </Stack>
      </TableCell>
      <TableCell>
        <Skeleton variant="text" />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" />
      </TableCell>
    </TableRow>
  );
}

export function ListTable({
  showSkeleton,
  data,
  forwardedRef,
  onEdit,
  onResend,
  onDelete,
}) {
  const { t } = useTranslation('users');

  return (
    <Paper variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sortDirection="desc">{t('table.name')}</TableCell>
            <TableCell>{t('table.email')}</TableCell>
            <TableCell>{t('table.phone')}</TableCell>
            <TableCell>{t('table.level')}</TableCell>
            <TableCell>{t('table.role')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.users?.map(user => (
            <TableRow
              key={user.personId}
              sx={{
                '& .MuiTableCell-root': {
                  px: 1.5,
                  py: 0.7,
                },
              }}
            >
              <TableCell>
                <NameAvatarCell user={user} />
              </TableCell>
              <TableCell>
                <Typography variant="body2">{user.email}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{user.phone}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{user.company?.name}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {user.roles.map(rol => rol.name).join(', ')}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <OptionsCell
                  user={user}
                  onEdit={() => onEdit(user)}
                  onResend={() => onResend(user)}
                  onDelete={() => onDelete(user)}
                />
              </TableCell>
            </TableRow>
          ))}
          {showSkeleton && <RowLoading forwardedRef={forwardedRef} />}
          {showSkeleton &&
            Array.from({ length: 9 }).map((_item, index) => (
              <RowLoading key={index} />
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
